import React from "react";
import { Link } from "react-router-dom";

// NEW UI: Landing-page-only footer; shared application footer remains available unchanged.
export default function LandingFooter() {
  const openPrivacySettings = () => {
    window.dispatchEvent(new Event("grantaide:open-privacy-settings"));
  };

  return <footer className="landing-footer"><div className="footer-grid">
    <div><div className="landing-brand">Grant<span>AI</span>de</div><p>Fast & easy grant writing</p></div>
    <div><b>PRODUCT</b><a href="#features">Features</a><a href="#pricing">Pricing</a><a href="#faq">FAQ</a></div>
    <div><b>ACCOUNT</b><Link to="/login">Sign In</Link><Link to="/signup">Sign Up</Link><a href="https://calendly.com/dream-big-/90min" target="_blank" rel="noopener noreferrer">Book a Demo</a></div>
    <div><b>LEGAL</b><Link to="/privacypolicy">Privacy Policy</Link><Link to="/termsofservice">Terms of Service</Link><button type="button" className="footer-privacy-button" onClick={openPrivacySettings}>Manage Privacy</button></div>
  </div><div className="footer-bottom"><span>© {new Date().getFullYear()} GrantAIde</span><span>Made for grant writers, by grant writers</span></div><div className="footer-gradient-line" /></footer>;
}
